export default __webpack_public_path__ + "assets/pdf/contoh.cbf1b132.pdf";